import { createSlice } from "@reduxjs/toolkit";
import { removeAllDPatterns } from "./detectedPatterns";
import { clearSelectedPatterns } from "./selectedPatterns";
import { removeAllSDPatterns } from "./selectedDetectedPatterns";
import { clearColdStartPatterns, clearDrawingArea } from "./coldStart";
import { clearTemporaryModel } from "./models";
import { addLayoutChart, setFullScreenChart } from "./chartLayout";
import { addChartData } from "./chartData";

const displaySlice = createSlice({
  name: "display",
  initialState: {
    display: "home",
    mode: null,
    branch: null,
  },
  reducers: {
    setGridDisplay: (state) => {
      state.mode = "null";
      state.display = "grid";
    },
    toggleGridDisplay: (state) => {
      if (state.display === "grid") state.display = "chart";
      else state.display = "grid";
    },
    setChartDisplay: (state) => {
      state.mode = "null";
      state.display = "chart";
    },
    setSelectPatternDisplayReducer: (state) => {
      state.mode = "drawModel";
      state.display = "chart";
    },
    setHomeDisplay: (state) => {
      state.display = "home";
      state.mode = null;
      state.branch = null;
    },
    setHeatMapDisplayReducer: (state) => {
      state.display = "heatMap";
      state.mode = null;
    },
    setDetectPatternsDisplayReducer: (state) => {
      state.display = "chart";
      state.mode = "detectPatterns";
    },
    setDrawModelDisplayReducer: (state) => {
      state.display = "coldStart";
      state.mode = "drawModelForTraining";
    },
    setSelectPatternsDisplayReducer: (state) => {
      state.display = "chart";
      state.mode = "selectPatternsForTraining";
    },
    setBranch: (state, action) => {
      state.branch = action.payload;
    },
  },
});

export const {
  setHomeDisplay,
  setGridDisplay,
  toggleGridDisplay,
  setChartDisplay,
  setBranch,
} = displaySlice.actions;

const {
  setHeatMapDisplayReducer,
  setDetectPatternsDisplayReducer,
  setDrawModelDisplayReducer,
  setSelectPatternsDisplayReducer,
  setSelectPatternDisplayReducer,
} = displaySlice.actions;

export const clearPatterns = (dispatch) => {
  dispatch(removeAllDPatterns());
  dispatch(clearSelectedPatterns());
  dispatch(removeAllSDPatterns());
  dispatch(clearColdStartPatterns());
  dispatch(clearDrawingArea());
  dispatch(clearTemporaryModel());
};

export const setHeatMapDisplay = () => (dispatch) => {
  clearPatterns(dispatch);
  dispatch(setHeatMapDisplayReducer());
};

export const setDetectPatternsDisplay = () => (dispatch) => {
  clearPatterns(dispatch);
  dispatch(setDetectPatternsDisplayReducer());
};
export const setDrawModelDisplay = () => (dispatch) => {
  clearPatterns(dispatch);
  dispatch(setDrawModelDisplayReducer());
  dispatch(setBranch("drawModel"));
};
export const setSelectPatternsDisplay = () => (dispatch) => {
  clearPatterns(dispatch);
  dispatch(setSelectPatternsDisplayReducer());
};
export const setSelectPatternDisplay = () => (dispatch) => {
  clearPatterns(dispatch);
  dispatch(setSelectPatternDisplayReducer());
  dispatch(addChartData(chart, collection, interval, id, true));
  if (!dispatch(addLayoutChart("6194f1b3e7de94cdee5834ac"))) return;
  dispatch(setFullScreenChart("6194f1b3e7de94cdee5834ac"));

  dispatch(setBranch("selectPattern"));
};

const chart = {
  name: "BTC/USDT",
  marketCap: null,
  charts: [
    {
      id: "6194f1b3e7de94cdee5834ac",
      name: "binance BTC/USDT 1h",
      stock_id: "BTC/USDT",
      interval: 60,
    },
  ],
  sCharts: false,
  dCharts: false,
  marketCapString: "",
};

const collection = {
  id: "6194f1b3e7de94cdee5834ad",
  name: "binance",
  common: true,
  created_at: "2021-11-17T12:12:35",
  type: "collection",
};

const interval = {
  interval: 60,
  string: "1h",
};
const id = "6194f1b3e7de94cdee5834ac";

export default displaySlice.reducer;
